import {dashboardService} from '../../helpers/dashboardService';

export const state = {
    chargerCounts: "",
    bookingCounts:"",
    userCounts:"",
    loading:true,
    dataCounts:[],
    todayBookings:{},
    todayChargers:{},
};

export const mutations = {
    chargerCount(state, payload) {
        state.chargerCounts = payload.data;
    },
    bookingCount(state, payload) {
        state.bookingCounts = payload.data;
    },
    userCount(state, payload) {
        state.userCounts = payload.data;
    },
    dataCount(state,payload){
        state.dataCounts = payload.data;
        state.todayBookings = payload.data.today_booking_data;
        state.todayChargers = payload.data.today_charger_data;
    },
    getChargerCount(state) {
        state.loading = true;
    },
    getBookingCount(state){
        state.loading = true;
    },
    getUserCount(state){
        state.loading = true;
    },
    getDataCount(state){
        state.loading = true;
    },
    getChargerCountFailure(state) {
        state.loading = false;
    },
    getBookingCountFailure(state) {
        state.loading = false;
    },
    getUserCountFailure(state) {
        state.loading = false;
    },
    getDataCountFailure(state){
        state.loading = false;
    }
};

export const actions = {
    async chargerCount({dispatch, commit},data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        commit("getChargerCount");
        await dashboardService.chargerCount(data)
        .then(
            response => {
                commit('chargerCount', response);
            },
            error => {
                commit("getChargerCountFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    },
    
    async bookingCount({dispatch, commit},data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        commit("getBookingCount");
        await dashboardService.bookingCount(data)
        .then(
            response => {
                commit('bookingCount', response);
            },
            error => {
                commit("getBookingCountFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    },

    async userCount({dispatch, commit},data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        commit("getUserCount");
        await dashboardService.userCount(data)
        .then(
            response => {
                commit('userCount', response);
            },
            error => {
                commit("getUserCountFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    },

    async dataCount({dispatch, commit},data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        commit("getDataCount");
        await dashboardService.dataCount(data)
        .then(
            response => {
                commit('dataCount', response);
            },
            error => {
                commit("getDataCountFailure", error,{root:true});
                dispatch("alert/error", error, {root: true});
            }
        );
    }
};

export const getters = {
    loading: state => state.loading,
    chargerCounts: state => state.chargerCounts,
    bookingCounts: state => state.bookingCounts,
    userCounts: state => state.userCounts,
    pagination:state => state.pagination,
    dataCounts:state => state.dataCounts,
    todayBookings:state => state.todayBookings,
    todayChargers:state => state.todayChargers,
};